import React from 'react';
import { Reveal } from './Reveal';
const puntos = [{
  emoji: '😟',
  text: 'Ves decoraciones hermosas en Instagram y no sabés cómo hacerlas'
}, {
  emoji: '💸',
  text: 'Pagás fortunas por decoradores y pensás que vos podrías hacerlo'
}, {
  emoji: '🤷',
  text: 'Empezaste a ver tutoriales sueltos en YouTube pero te perdés'
}, {
  emoji: '😰',
  text: 'Querés emprender pero no sabés por dónde arrancar'
}, {
  emoji: '🎈',
  text: 'Te encantan los globos pero no le encontrás la vuelta técnica'
}];
export function Problema() {
  return <section className="w-full bg-[#f6f1fb] py-24" data-id="element-133" data-mp="3amu81yitoc5g">
      <div className="mx-auto max-w-5xl px-6" data-id="element-134" data-mp="3alj3vxlgt2dt">
        <Reveal data-id="element-135" data-mp="35mprk8hwzhf8">
          <h2 className="font-display text-center text-3xl font-semibold text-[#2f2a33] sm:text-4xl" data-id="element-136" data-mp="35o96nvru3mff">
            ¿Te sentís identificada con esto?
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2" data-id="element-137" data-mp="1b9q2lorn9ava">
          {puntos.map((p, i) => <Reveal key={i} delay={i * 0.06} data-id="element-138" data-mp="37pvt2i8cpwiy" data-mpi={i}>
              <div className="flex h-full items-start gap-4 rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/5" data-id="element-139" data-mp="37qx1sg1wa6xi">
                <span className="text-3xl leading-none" data-id="element-140" data-mp="3cmcidfraegxm">{p.emoji}</span>
                <p className="text-lg text-[#2f2a33]/85" data-id="element-141" data-mp="3goh7q2apcreg">{p.text}</p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-142" data-mp="3lilhsuf9lfjr">
          <p className="mx-auto mt-12 max-w-2xl text-center text-xl font-medium text-[#a78bdb]" data-id="element-143" data-mp="3qgd7dhsfspks">
            Si dijiste sí a alguno de estos puntos, este curso es exactamente lo
            que necesitás.
          </p>
        </Reveal>
      </div>
    </section>;
}